define('bindingHandlers/tooltip2',[
    'jquery',
    'lib/knockout',
    'lib/tether'
], function ($, ko, Tether) {
    'use strict';

    var SHOW_DELAY = 200; //ms
    var ARROW_OFFSET = 30; //px
    var timeoutHandle;
    var $tooltip = $("<div class='tooltip'/>");

    var tetherHandle = new Tether({
        element: $tooltip,
        target: $("<div/>"),
        attachment: 'bottom middle',
        targetAttachment: 'top middle',
        constraints: [{
            to: 'window',
            attachment: 'together'
        }]
    });

    var createTooltipDiv = function (text) {
        $tooltip = $("<div class='tooltip'/>");
        var $inner = $("<div class='tooltip-inner'></div>");
        var $content = $("<div/>");
        $content.html(text);
        $inner.append($content);
        $tooltip.append($inner);
        $tooltip.append("<div class='tooltip-arrow tooltip-arrow-down tooltip-arrow-left' />");
    };

    var createTetherHandle = function ($element, offset) {
        var options = {
            element: $tooltip,
            target: $element,
            attachment: 'bottom middle',
            targetAttachment: 'top middle',
            constraints: [{
                to: 'window',
                attachment: 'together'
            }]
        };
        if (offset) {
            options.offset = offset.top + 'px ' + offset.left + 'px';
        }
        tetherHandle.setOptions(options);
        return tetherHandle;
    };

    var createTooltip = function ($element, text) {
        createTooltipDiv(text);
        //we need to create a dummy tether handle and ask it to reposition itself so we can manually calculate it's offset
        createTetherHandle($element).position();
        if ($tooltip.offset().left < 0) {
            createTetherHandle($element, {top: 0, left: $tooltip.offset().left}); // keep inside window
        } else {
            var left = -($tooltip.width() / 2) + ARROW_OFFSET; // account for non-centered arrow
            createTetherHandle($element, {top: 0, left: left});
        }
    };


    var showTooltip = function () {
        timeoutHandle = setTimeout(function () {
            openTooltip();
        }, SHOW_DELAY);
    };

    var openTooltip = function () {
        $tooltip.addClass('tooltip-is-open');
        clearTimeout(timeoutHandle);
        timeoutHandle = null;
    };

    var closeTooltip = function () {
        if (timeoutHandle) {
            clearTimeout(timeoutHandle);
        } else {
            $tooltip.removeClass('tooltip-is-open');
            tetherHandle.destroy();
        }
    };

    var isOpen = function () {
        return $tooltip.hasClass('tooltip-is-open');
    };

    var cleanupTooltip = function ($element) {
        if ($element) {
            closeTooltip();
            $element.off('.tooltip2');
        }
    };

    var generateLocalizedString = function (value) {
        var text = value.name;
        if (ko.i18n.keyExists(value.name) && value.data) {
            text = ko.i18n.renderString(value.name, value.data, value.locale);
        } else if (ko.i18n.keyExists(value.name)) {
            text = ko.i18n.renderString(value.name);
        }
        return text;
    };

    /**
     * @param name The text to be displayed in tooltip
     *
     * Optional
     * @param data The data to be passed into ko.i18n.renderString
     *
     * Usage: tooltip2: {name:'hello world'}
     */
    ko.bindingHandlers.tooltip2 = {
        init: function (element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            var $element = $(element);
            var text = generateLocalizedString(value);

            $element.on('mouseenter.tooltip2', function () {
                createTooltip($element, text);
                showTooltip();
            });

            $element.on('mouseleave.tooltip2', function () {
                closeTooltip();
            });

            $element.on('click.tooltip2', function () {
                if (isOpen()) {
                    closeTooltip();
                } else {
                    openTooltip();
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                cleanupTooltip($element);
                $tooltip.remove();
            });
        },
        update: function (element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            var $element = $(element);
            var text = generateLocalizedString(value);

            // Rebind mouseenter with new string
            $element.off('mouseenter.tooltip2');
            $element.on('mouseenter.tooltip2', function () {
                createTooltip($element, text);
                showTooltip();
            });
        }
    };
});

